/**
 * Promise that resolves when Office.js is fully initialized.
 * Components can await this before calling Office APIs.
 *
 * Extracted to its own module to avoid circular imports
 * (index.tsx → App → AuthProvider → index.tsx).
 */
let resolveOfficeReady: () => void = () => {};
export const officeReadyPromise = new Promise<void>((resolve) => {
  resolveOfficeReady = resolve;
});

export function markOfficeReady(): void {
  resolveOfficeReady();
}
